import { Component, OnInit, EventEmitter, Output, Input, forwardRef } from '@angular/core';
import { VenueService } from '../../services/venue.service';
import { RequestOptions, Headers, Http} from '@angular/http';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { environment } from '../../../environments/environment';
import { CompleterService, CompleterData, RemoteData  } from 'ng2-completer';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

const noop = () => {
};

export const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => VenueCompleterComponent),
    multi: true
};

@Component({
  selector: 'venue-completer',
  templateUrl: './venue-completer.component.html',
  styleUrls: ['./venue-completer.component.css'],
  styles: [`:host >>> .completer-dropdown {
              overflow-y: auto;
              max-height: 400px;
            }`],
  providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR]
})
export class VenueCompleterComponent implements OnInit, ControlValueAccessor {

  private innerValue: any = '';

  remote: RemoteData;
  real_id:number;
  name:string;
  id:string;
  lat:number;
  lng:number;
  address:string;
  country_id: number;
  admin1_id: number;
  admin2_id: number;
  venue:any;

  @Input() disabled:boolean;
  @Input() invalid:boolean;
  @Output() venueData = new EventEmitter();

  private onTouchedCallback: () => void = noop;
  private onChangeCallback: (_: any) => void = noop;


  constructor(private completerService: CompleterService,
  private auth:AuthService,
  private req: RequestOptions

) {
    // UploadFile
  }

    ngOnInit() {

    let header = new Headers();
    header.append('Content-Type', 'application/json');
    header.append('X-API-KEY', environment.apiKey);
    header.append('X-ACCESS-TOKEN', this.auth.idToken);
    this.req = new RequestOptions({headers: header});

    this.remote = this.completerService.remote(null, "name", "name");
    this.remote.urlFormater(term => {
            if (term == ""){
              return environment.apiRoot+`/venue/`;
            }else{
              return environment.apiRoot+`/venue/?&query=${term}`;
            }

        });
    this.remote.requestOptions(this.req);
    this.remote.dataField("data");
  }

  get value(): any {
        return this.innerValue;
  };

  set value(v: any) {
        if (v !== this.innerValue) {
            this.innerValue = v;
            this.onChangeCallback(v);
        }
  }
  registerOnChange(fn: any) {
        this.onChangeCallback = fn;
    }

    //From ControlValueAccessor interface
  registerOnTouched(fn: any) {
        this.onTouchedCallback = fn;
  }

  writeValue(value: any) {
        if (value !== this.innerValue) {
            this.innerValue = value;
        }
  }

  onSelected($event){
    if ($event){
      this.id = $event.originalObject.id;
      this.real_id = $event.originalObject.real_id;
      this.lat = $event.originalObject.lat;
      this.lng = $event.originalObject.lng;
      this.address = $event.originalObject.address;
      this.country_id = $event.originalObject.country;
      this.admin1_id = $event.originalObject.countryAdmin1;
      this.admin2_id = $event.originalObject.countryAdmin2;
      this.name = $event.title;
    }else{
      this.real_id = null;
      this.name = null;
      this.id = null;
      this.lat = 0;
      this.lng = 0;
      this.address = null;
    }

    this.venueData.emit(
      {
        id: this.id,
        name:this.name,
        real_id: this.real_id,
        lat: this.lat,
        lng: this.lng,
        address: this.address,
        admin1: this.admin1_id,
        admin2: this.admin2_id,
        country: this.country_id
      }
    );
  }

}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/venue-completer/venue-completer.component.ts